import api from "../../../store/AuthHeader";

const addFeedBack = (payload: any) => {
    return api.post("FeedBack", payload);
}

export default {
    addFeedBack
};